var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 50,
    viewBox: "0 0 52 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.8125 44.0709L46.0107 35.8726L44.1808 34.0427L39.1509 39.0725V27.6534H36.4739V39.0725L31.4441 34.0427L29.6142 35.8726L37.8125 44.0709ZM0 42.6225V0L37 15.5L32 16C32.5 16 33.0559 15.6871 32 16L3 4V19L20.4537 21.2956L3 23V38L19 31.7918C18.5 32 18.6674 32.0373 18.6924 31.9111C18.5059 32.8435 18.4113 33.4326 18.3939 33.9171V34.7484L0 42.6225ZM37.8125 50C33.919 50 30.5893 48.6171 27.8234 45.8512C25.0576 43.0853 23.6746 39.7557 23.6746 35.8622C23.6746 31.9687 25.0576 28.6391 27.8234 25.8732C30.5893 23.1074 33.919 21.7244 37.8125 21.7244C41.7059 21.7244 45.0356 23.1074 47.8014 25.8732C50.5673 28.6391 51.9502 31.9687 51.9502 35.8622C51.9502 39.7557 50.5673 43.0853 47.8014 45.8512C45.0356 48.6171 41.7059 50 37.8125 50ZM3 29.0181V23V19V4V38V29.0181Z",
    fill: "#22668D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.cbf3ca9dc21e2c9b60f1ef2c6f8baf20.svg";
export { ForwardRef as ReactComponent };